import { EWC_CLASSES } from '../../Constants';
import { MATERIAL_PREDICTION_CLASSES } from '../../api/resources/materialClassification.constants';
import { MaterialConditionDTO } from '../../api/generated';
import { SOIL_CATEGORY_VALUES } from '../../api/resources/soilClassification.constants';
import { MaterialOption } from './types';

export const TEMP_ID_PREFIX = 'temp-';

// from material classification evaluator schema v1
export const MATERIAL_OPTIONS: MaterialOption[] = [
  ...EWC_CLASSES.filter((ewc) => MATERIAL_PREDICTION_CLASSES.some((className) => className === ewc.label)).map(
    (ewc) => ({
      className: ewc.label as MaterialConditionDTO['className'],
      ewcClass: ewc.class,
      label: `material.class.${ewc.label}`,
    })
  ),
  ...MATERIAL_PREDICTION_CLASSES.filter((className) => !EWC_CLASSES.some((ewc) => ewc.label === className)).map(
    (className) => ({
      className,
      ewcClass: '',
      label: `material.class.${className}`,
    })
  ),
];

const defaultCategory = Object.keys(SOIL_CATEGORY_VALUES)[0];
const defaultValue = SOIL_CATEGORY_VALUES[defaultCategory][0];
export const DEFAULT_CONDITIONS = {
  material: { type: 'material', className: MATERIAL_OPTIONS[0].className, probability: 0.5 },
  soil: {
    type: 'soil',
    category: defaultCategory,
    value: defaultValue,
    minConfidence: 0.5,
  },
  edge: { type: 'edge', operator: '>=', value: 0.6, thresholdCount: 1, thresholdMode: 'min' },
} as const;
